// ESM-Huelle - seit RKSV-Umbau (tools/RKSV-ONLINE-SIGNATUR.md) spricht die
// Oberflaeche NICHT mehr selbst mit der Karte: der lokale Kassenserver
// signiert (Karte oder A-Trust online), prueft die Signatur und fuehrt die
// SEE-Historie. PIN und APDUs sind hier raus. Schnittstelle nach aussen
// bleibt: POS.Smartcard.init()/sign(), isworking/wasworking fuer den
// Sammelbeleg (receipt.js checkPrevReceipt). An der Legacy-Naht immer
// jQuery-Deferred (tools/MODERNISIERUNG.md Regel 4).
import { schlussbelegSichern } from './schlussbeleg.js';

function CSmartcard() {
    this.isworking = true;
    this.wasworking = true;
    this.zustand = null;
    this.kandidat = null;
    // Zuletzt bekannter Modus ("karte"/"atrust") - bleibt ueber init-Fehler
    // erhalten, damit die Ausfall-Meldung den passenden Text hat.
    this.modus = null;
    // Ruling 25: ein in DIESER Sitzung nach gescheitertem Wechsel verworfener
    // Kandidat wird von init() nicht wieder scharf gemacht (kein SZR-Kreislauf);
    // der naechste Kassenstart (neue Seite, neues CSmartcard) versucht neu.
    this.kandidatVerworfen = false;
    // Nacharbeit B4: Kasse endgueltig ausser Betrieb ({seit, belegNr} vom
    // Kassenserver) - dann keine Belege mehr, auch keine Ausfall-Belege.
    this.ausserBetrieb = null;
}

// Meldungstexte (pixelrelevant, woertlich). Karte: wie vor dem Umbau.
CSmartcard.MELDUNG_KARTE = "Smartcard-Leser entfernt! Bitte Smartcard ein wenig ausstecken und dann wieder einstecken und USB Anschluss des Smartcard-Lesers prüfen. Sollte das nicht helfen bitte Support anrufen!";
CSmartcard.MELDUNG_KARTE_START = "Smartcard-Leser entfernt! Bitte Smartcard-Leser am USB Anschluss anschliessen bzw. Support anrufen. Es kann jedoch normal weiterbearbeitet werden!";
// Nacharbeit B4 (Nutzer 1.10.2026): Barumsatz an einer abgemeldeten Kasse.
CSmartcard.MELDUNG_AUSSER_BETRIEB = "Diese Kasse ist beim Finanzamt abgemeldet (außer Betrieb). Es können keine Belege mehr ausgestellt werden!";
CSmartcard.MELDUNG_ATRUST = "Signatur-Dienst (A-Trust) nicht erreichbar! Bitte Internetverbindung prüfen. Es kann normal weiterkassiert werden - der Beleg trägt den Vermerk \"Sicherheitseinrichtung ausgefallen\". Sollte das länger dauern bitte Support anrufen!";

CSmartcard.prototype.ausserBetriebMelden = function () {
    log.add(1, "Error", "RKSV", "Beleg verweigert: Kasse ausser Betrieb");
    POS.message.show(CSmartcard.MELDUNG_AUSSER_BETRIEB, "warning", "OK");
};

// Kassenstart (cpos.js) an einer gesperrten Kasse: fehlt der signierte
// Schlussbeleg in BONREG, wird er nachgetragen (Fix-Runde 1, Important 2).
// Meldung nur, wenn das nicht geht.
// Erst nach der Anmeldung (die BON-Zeile braucht einen Benutzer, Trans.UID).
CSmartcard.prototype.schlussbelegBeimStart = function () {
    if (!(window.Trans && Trans.UID)) {
        setTimeout(function () { POS.Smartcard.schlussbelegBeimStart(); }, 2000);
        return;
    }
    $.when(schlussbelegSichern()).then(function (s) {
        if (s.status === "fehler")
            POS.message.show("Die Kasse ist gesperrt, der Schlussbeleg konnte aber nicht ins Belegprotokoll übernommen werden. Bitte Support anrufen!", "warning", "OK");
    });
};

CSmartcard.prototype.istAtrust = function () {
    return this.modus === "atrust";
};

// Start-Meldung (cpos.js). Karte wie bisher: init() zeigt zuerst die
// Ausfall-Meldung (cardError), danach cpos.js diesen Starttext (Ruling 23).
// A-Trust: GENAU eine Meldung, nur dieser Text (Ruling 19).
CSmartcard.prototype.startMeldung = function () {
    return this.istAtrust() ? CSmartcard.MELDUNG_ATRUST : CSmartcard.MELDUNG_KARTE_START;
};

// Seriennummer aus dem signierten Beleg selbst (JWS-Eingabe "Header.Payload",
// Payload = maschinenlesbarer Code "_R1-AT1_..._<Seriennummer>_<SigVorBeleg>").
// Base64-Felder enthalten nie "_", die Seriennummer ist das vorletzte Feld.
CSmartcard.seriennummerImBeleg = function (jwsEingabe) {
    try {
        var p = String(jwsEingabe).split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        while (p.length % 4) p += "=";
        var felder = atob(p).split("_");
        return felder.length > 2 ? felder[felder.length - 2] : null;
    } catch (e) {
        return null;
    }
};

// neu=true: Kassenserver liest Konfig/Historie neu ("Kassenstart").
// still=true: Resynchronisation nach einem Ausfall-Beleg (Ruling 21) - die
// Meldung kam dort schon, init() meldet dann nichts.
CSmartcard.prototype.init = function (neu, still) {
    var me = this;
    var def = jQuery.Deferred();
    $.ajax({
        url: "rksv/zustand" + (neu ? "?neu=1" : ""), cache: false, timeout: 30000,
        success: function (z) {
            me.zustandFehler = false;
            me.zustand = z;
            me.kandidat = z && z.kandidat && !me.kandidatVerworfen ? z.kandidat : null;
            var aktiv = z && z.aktiv;
            if (aktiv && aktiv.modus) me.modus = aktiv.modus;
            window.sigCertificateSerialNumber = aktiv && aktiv.serialHex && aktiv.serialHex !== "0" ? aktiv.serialHex : 0;
            me.ausserBetrieb = z && z.ausserBetrieb ? z.ausserBetrieb : null;
            if (z && z.umstellung) log.add(1, "Warning", "RKSV", z.umstellung);
            me.isworking = !!(aktiv && !z.ausfall);
            if (!me.isworking) me.startFehler(still);
            def.resolve(me.isworking);
        },
        error: function () {
            // Zustand/Modus der letzten erfolgreichen Abfrage bleiben stehen.
            // zustandFehler: die Sperre ist damit UNBEKANNT (Nacharbeit B Fix-Runde 2).
            me.zustandFehler = true;
            me.isworking = false;
            me.startFehler(still);
            def.resolve(false);
        }
    });
    return def.promise();
};

// kandidat=true nur fuer den Nullbeleg SZR beim Wechsel - dessen Ergebnis
// beruehrt isworking/wasworking (Ausfall der AKTIVEN Einheit) nicht.
// schlussbeleg=true (Nacharbeit B): Schlussbeleg SCH. Er bekommt NIE den
// Ausfall-Vermerk - scheitert die Signatur, wird abgelehnt (reject mit Grund),
// es entsteht kein Beleg. Eine gesperrte Kasse (ausser Betrieb) lehnt jede
// Signatur ab (reject) - nie ein Ausfall-Beleg.
CSmartcard.prototype.sign = function (plaintext, kandidat, schlussbeleg) {
    var me = this;
    var def = jQuery.Deferred();
    var gesperrt = function () {
        me.ausserBetrieb = me.ausserBetrieb || { seit: null, belegNr: null };
        me.ausserBetriebMelden();
        def.reject("Kasse ausser Betrieb");
    };
    var schlussAbgelehnt = function (a) {
        // isworking bleibt: es gab keinen Ausfall-BELEG (also auch keinen
        // Sammelbeleg AZR); der naechste Barbeleg signiert ganz normal bzw.
        // bekommt dann wie immer den Ausfall-Vermerk.
        log.add(1, "Error", "RKSV", "Schlussbeleg nicht signiert: " + ((a && a.grund) || "keine Antwort"));
        def.reject((a && a.grund) || "keine Antwort");
    };
    var ausgefallen = function () {
        if (!kandidat) {
            me.cardError(me);
            me.wasworking = me.isworking;
            me.isworking = false;
        }
        /*Der Hinweis „Sicherheitseinrichtung ausgefallen“ ist zusätzlich gut sichtbar
        am Beleg (§ 11) anzubringen. Nach Wiederinbetriebnahme der Signaturerstellungseinheit ist zusätzlich
        über die Belege, die während des jeweiligen Ausfalles mit dem Hinweis „Sicherheitseinrichtung
        ausgefallen“ zu versehen waren, ein signierter Sammelbeleg mit Betrag Null (0) zu erstellen und im
        Datenerfassungsprotokoll zu speichern.*/
        def.resolve(new Buffer('Sicherheitseinrichtung ausgefallen'));
    };
    $.ajax({
        url: "rksv/sign", type: "POST", contentType: "application/json", timeout: 10000,
        data: JSON.stringify(schlussbeleg ? { daten: plaintext, kandidat: false, schlussbeleg: true } : { daten: plaintext, kandidat: !!kandidat }),
        success: function (a) {
            if (a && !a.ok && a.ausserBetrieb) return gesperrt();
            if (schlussbeleg && !(a && a.ok && a.signatur)) return schlussAbgelehnt(a);
            if (a && a.ok && a.signatur) {
                // Ruling 21: die Seriennummer im Beleg MUSS die der Einheit sein,
                // die tatsaechlich signiert hat - sonst Ausfall-Vermerk und
                // Zustand neu lesen (window.sigCertificateSerialNumber, kandidat).
                var imBeleg = CSmartcard.seriennummerImBeleg(plaintext);
                if (a.serialHex === undefined || a.serialHex === null ||
                    String(imBeleg).toUpperCase() !== String(a.serialHex).toUpperCase()) {
                    log.add(1, "Error", "RKSV", "Seriennummer im Beleg (" + imBeleg + ") passt nicht zur signierenden Einheit (" + a.serialHex + ") - Beleg als Ausfall");
                    if (schlussbeleg) { schlussAbgelehnt({ grund: "Seriennummer passt nicht", ausfall: false }); me.init(false, true); return; }
                    ausgefallen();
                    me.init(false, true);
                    return;
                }
                if (!kandidat) {
                    me.wasworking = me.isworking;
                    me.isworking = true;
                }
                if (a.ausserBetrieb) me.ausserBetrieb = a.ausserBetrieb;   // eben signierter Schlussbeleg
                def.resolve(new Buffer(a.signatur, "base64"));
            } else {
                ausgefallen();
            }
        },
        error: function () { if (schlussbeleg) schlussAbgelehnt(null); else ausgefallen(); }
    });
    return def.promise();
};

// Nach einem Ausfall-Beleg, vor dem naechsten Barbeleg: ist die Einheit
// wieder da? Der Kassenserver probt mit einer GEPRUEFTEN Signatur. Wieder in
// Betrieb -> isworking=true, wasworking=false: checkPrevReceipt erzeugt den
// Sammelbeleg AZR. Keine Meldung (die kam schon beim Ausfall-Beleg).
// kurz:true (Nacharbeit A1): der Kassenserver probt mit je 1 s fuer
// Zertifikat und Signatur - ein Bon wartet im Ausfall hoechstens ~2 s
// zusaetzlich; die Scheduler-Probe im Kassenserver behaelt die vollen Limits.
CSmartcard.prototype.pruefen = function () {
    var me = this;
    var def = jQuery.Deferred();
    $.ajax({
        url: "rksv/probe", type: "POST", contentType: "application/json", timeout: 10000, data: JSON.stringify({ kurz: true }),
        success: function (a) {
            if (a && a.ok && !a.ausfall) {
                me.wasworking = false;
                me.isworking = true;
            }
            def.resolve(me.isworking);
        },
        error: function () { def.resolve(me.isworking); }
    });
    return def.promise();
};

// Nullbeleg SZR ist signiert und steht als letzter Beleg in BONREG: der
// Kassenserver vollzieht den Wechsel (SEE-Historie, Ereignis see_wechsel).
CSmartcard.prototype.aktivieren = function (abReceiptID, qr, jws) {
    var me = this;
    var def = jQuery.Deferred();
    $.ajax({
        url: "rksv/see/aktivieren", type: "POST", contentType: "application/json", timeout: 15000,
        data: JSON.stringify({ abReceiptID: abReceiptID, qr: qr, jws: jws }),
        success: function (a) {
            if (a && a.ok && a.aktiv) {
                window.sigCertificateSerialNumber = a.aktiv.serialHex;
                if (me.zustand) me.zustand.aktiv = a.aktiv;
                if (a.aktiv.modus) me.modus = a.aktiv.modus;
            } else {
                if (a && a.fehler) log.add(1, "Error", "RKSV", "SEE-Wechsel abgelehnt: " + a.fehler);
                me.kandidatVerworfen = true;
            }
            // Erfolg oder nicht: in dieser Sitzung kein weiterer Nullbeleg -
            // der Kassenserver wiederholt einen gescheiterten Wechsel beim
            // naechsten Start (Vorpruefung, neuer Kandidat).
            me.kandidat = null;
            def.resolve(!!(a && a.ok && a.aktiv));
        },
        error: function () {
            me.kandidat = null;
            me.kandidatVerworfen = true;
            def.resolve(false);
        }
    });
    return def.promise();
};

// Einheit bei init() nicht verfuegbar: Karte wie bisher mit Ausfall-Meldung
// (danach folgt beim Start der Starttext aus cpos.js); A-Trust und die stille
// Resynchronisation nur ins Log.
CSmartcard.prototype.startFehler = function (still) {
    if (!still && !this.istAtrust()) {
        this.cardError(this);
    } else {
        log.add(1, "Error", "SmartCard-Reader oder Karte entfernt");
    }
};

// Ruling 5 (Nutzer 30.9.2026): Meldung bei JEDEM ausgefallenen Beleg wie
// bisher; mit A-Trust (online) ein eigener Text, die Karte behaelt den alten.
CSmartcard.prototype.cardError = function (me) {
    log.add(1, "Error", "SmartCard-Reader oder Karte entfernt");
    POS.message.show(me.istAtrust() ? CSmartcard.MELDUNG_ATRUST : CSmartcard.MELDUNG_KARTE, "warning", "OK");
    me.isworking = false;
};

//@ sourceURL=CLS_CSmartcard.js

export { CSmartcard };
